import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ProductOffering } from 'anchor-shared/lib/model/entity/productOffering';
import { Vessel } from 'anchor-shared/lib/model/entity/vessel';

@Component({
  selector: 'app-hours-between',
  templateUrl: './hours-between.component.html',
  styleUrls: ['./hours-between.component.scss'],
})
export class HoursBetweenComponent implements OnInit {
  @Input()
  vessel: Vessel;

  @Output()
  hoursBetweenSelected = new EventEmitter<number>();

  hoursBetween = 1;
  hoursBetweenOptions = [
    {
      label: '30 minutes',
      value: 0.5,
    },
    {
      label: '1 hour',
      value: 1,
    },
    {
      label: '2 hours',
      value: 2,
    },
    {
      label: '3 hours',
      value: 3,
    },
  ];

  @Input()
  productOffering: BehaviorSubject<Partial<ProductOffering>>;

  constructor() {}

  ngOnInit() {
    this.initCurrentState();
  }

  hoursBetweenChanged() {
    this.productOffering.next({
      ...this.productOffering.value,
      hoursBetween: this.hoursBetween,
      customAvailabilityTimes: null,
    });
  }

  private initCurrentState(): void {
    if (this.productOffering.value && this.productOffering.value.hoursBetween) {
      this.hoursBetween = this.productOffering.value.hoursBetween;
    }
    this.productOffering.next({
      ...this.productOffering.value,
      hoursBetween: this.hoursBetween ? this.hoursBetween : 1,
    });
  }
}
